var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreateDir = function SvgCreateDir(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M6.947 9.474c0 .214.026.423.057.631h-5.74A1.263 1.263 0 0 1 0 8.842V1.263C0 .563.562 0 1.263 0h3.79l1.263 1.263h5.052c.695 0 1.264.562 1.264 1.263v3.67a3.9 3.9 0 0 0-1.264-.455V2.526H1.263v6.316h5.741a4 4 0 0 0-.057.632m4.421-.632V6.947h-1.263v1.895H8.211v1.263h1.894V12h1.263v-1.895h1.895V8.842z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreateDir);
export { ForwardRef as ReactComponent };